export class Token {

  private _accessToken: string;
  private _refreshToken: string;

  constructor(accessToken: string, refreshToken: string) {
    this._accessToken = accessToken;
    this._refreshToken = refreshToken;
  }

  public get accessToken(): string {
    return this._accessToken;
  }

  public get refreshToken(): string {
    return this._refreshToken;
  }

  public set accessToken(value: string) {
    this._accessToken = value;
  }

  public set refreshToken(value: string) {
    this._refreshToken = value;
  }
}
